export default __webpack_public_path__ + "static/logo-d225609781eff66d81ecfc072f033308.png";